import React from 'react';
import { isMobile } from 'react-device-detect';
import { Link } from "react-router-dom";
import { useTheme } from '@material-ui/core';
import { BreadcrumbLinkProps } from './BreadcrumbLink.types';

export const BreadcrumbLink = ({icon, text, to} : BreadcrumbLinkProps) => {
    const theme = useTheme();
    return (
        <Link
            to={to}
            style={{ display: 'flex', textDecoration: 'none', color: `${theme.palette.text.secondary}` }}
        >
            {icon}
            {!isMobile && text}
        </Link>
    )
}